import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';

const PostRedirect = () => {
  const { postId } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isRedirecting, setIsRedirecting] = useState(true);

  useEffect(() => {
    let timeoutId = null;
    let iframe = null;
    let visibilityHandler = null;
    let appOpened = false;

    const detectDevice = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      
      // Check for iOS (iPad, iPhone, iPod)
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'ios';
      }
      
      // Check for Android
      if (/android/i.test(userAgent)) {
        return 'android';
      }
      
      // Default to desktop
      return 'desktop';
    };

    const attemptDeepLink = (deviceType) => {
      // Universal Links (iOS) and App Links (Android) work automatically:
      // - If app is installed: OS routes to app immediately (user never sees this page)
      // - If app NOT installed: This web page loads, so we redirect to store
      
      if (deviceType === 'ios') {
        // For iOS: Try custom scheme first, then redirect to App Store if app doesn't open
        const customSchemeUrl = `shadowzapp://post/${postId}`;
        const appStoreUrl = 'https://apps.apple.com/in/app/shadowz/id6747656833';
        
        // Track if page becomes hidden (indicating app opened)
        visibilityHandler = () => {
          if (document.hidden) {
            appOpened = true;
          }
        };
        document.addEventListener('visibilitychange', visibilityHandler);
        
        // Try to open app via custom scheme using iframe method
        iframe = document.createElement('iframe');
        iframe.style.border = 'none';
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.style.position = 'absolute';
        iframe.src = customSchemeUrl;
        document.body.appendChild(iframe);
        
        // After a delay, if app didn't open, redirect to App Store
        timeoutId = setTimeout(() => {
          if (!appOpened) {
            window.location.href = appStoreUrl;
          }
        }, 2000);
        
      } else if (deviceType === 'android') {
        // For Android: Use Intent URL which handles fallback to Play Store automatically
        const intentUrl = `intent://post/${postId}#Intent;scheme=shadowzapp;package=com.hf.shadowz;S.browser_fallback_url=https://play.google.com/store/apps/details?id=com.hf.shadowz&hl=en_IN;end`;
        const playStoreUrl = 'https://play.google.com/store/apps/details?id=com.hf.shadowz&hl=en_IN';
        
        // Track if page becomes hidden (indicating app opened)
        visibilityHandler = () => {
          if (document.hidden) {
            appOpened = true;
          }
        };
        document.addEventListener('visibilitychange', visibilityHandler);
        
        // Try Intent URL (will redirect to Play Store if app not installed)
        window.location.href = intentUrl;
        
        // Fallback: if still on page after delay, redirect to Play Store
        timeoutId = setTimeout(() => {
          if (!appOpened) {
            window.location.href = playStoreUrl;
          }
        }, 2000);
        
      } else {
        // Desktop - redirect to home page immediately
        setIsRedirecting(false);
        navigate('/', { replace: true });
      }
    };

    const deviceType = detectDevice();
    
    // Small delay to ensure component is mounted
    const initTimer = setTimeout(() => {
      attemptDeepLink(deviceType);
    }, 100);
    
    // Cleanup function
    return () => {
      clearTimeout(initTimer);
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      if (visibilityHandler) {
        document.removeEventListener('visibilitychange', visibilityHandler);
      }
      if (iframe && iframe.parentNode) {
        document.body.removeChild(iframe);
      }
    };
  }, [postId, navigate]);

  // Show loading message while redirecting
  if (isRedirecting) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        flexDirection: 'column',
        gap: '20px',
        fontFamily: 'Arial, sans-serif'
      }}>
        <div style={{ fontSize: '18px', fontWeight: '500' }}>Opening app...</div>
        <div style={{ fontSize: '14px', color: '#666' }}>
          If the app doesn't open, you'll be redirected to download it.
        </div>
      </div>
    );
  }
  
  return null;
};

export default PostRedirect;

